module.exports = __webpack_public_path__ + "img/wx-msg.8d965206.png";